import * as React from 'react'
import { connect } from 'react-redux'
import { BgcVendor } from '../../../constants'
import { trackBackgroundCheckSteps } from '../../../events'
import * as DA from '../../../typeModules/events'
import NccBackgroundCheckLinker from './ncc'
import { BackgroundCheckLinkerProps, BgcVendorComponentMapProps } from './types'

const BgcVendorComponentMap: BgcVendorComponentMapProps = {
  [BgcVendor.NCC]: NccBackgroundCheckLinker,
}

const BackgroundCheckLinker: React.FC<BackgroundCheckLinkerProps> = ({
  uniqueLink,
  vendor,
  countryCode,
  trackBackgroundCheckSteps,
}) => {
  React.useEffect(() => {
    trackBackgroundCheckSteps({
      action: DA.EventActions.Rendered,
      page: DA.BackgroundCheckPages.BackgroundCheckLinker,
      value: vendor,
    })
  }, [trackBackgroundCheckSteps, vendor])

  const handleClick = (data: Record<string, string>) => {
    trackBackgroundCheckSteps({
      action: DA.EventActions.Clicked,
      page: DA.BackgroundCheckPages.BackgroundCheckLinker,
      value: vendor,
      ...data,
    })
  }

  const BgcVendorComponent = BgcVendorComponentMap[vendor]

  if (!BgcVendorComponent) {
    console.warn(`[BGCLinker] Background check vendor not supported: ${vendor}`)
    return null
  }

  return (
    <BgcVendorComponent
      uniqueLink={uniqueLink}
      trackClick={handleClick}
      countryCode={countryCode}
    />
  )
}

const mapDispatchToProps = {
  trackBackgroundCheckSteps,
}

export default connect(null, mapDispatchToProps)(BackgroundCheckLinker)
